import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { COLORS } from '../../../../constants/styles';

import styles from '../index.styl';

const RadioMark = ({ checked, size, color }) => {
  const width = size;
  const height = size;
  const cx = size / 2;
  const cy = size / 2;
  const strokeWidth = 1;
  const outerRadius = size / 2 - strokeWidth;
  const innerRadius = outerRadius / 1.6;

  return (
    <svg {...{ width, height }} styleName={checked ? 'checked' : 'unchecked'}>
      <circle
        {...{ cx, cy, strokeWidth }}
        r={outerRadius}
        stroke={checked ? color : COLORS.fontLighter}
        fill="white"
      />
      <If condition={checked}>
        <circle {...{ cx, cy }} r={innerRadius} fill={color} />
      </If>
    </svg>
  );
};

RadioMark.propTypes = {
  checked: PropTypes.bool,
  size: PropTypes.number,
  color: PropTypes.string,
};

RadioMark.defaultProps = {
  checked: null,
  size: 12,
  color: COLORS.blueMedium,
};

export default CSSModules(RadioMark, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/RadioInput/RadioMark/index.jsx